import { initCompanyArchiveFitHeading } from './company_archive_fit_heading'
import { initCompanyArchiveAreaContext } from './company_area_context'
import { initBottomCvArea } from './ui/bottom_cv_area'

function initPagedArchiveInteractions() {
  if (document.documentElement.dataset.companyArchivePagedInteractionsInitialized === 'true') {
    return
  }

  document.documentElement.dataset.companyArchivePagedInteractionsInitialized = 'true'
  initBottomCvArea()
  initCompanyArchiveAreaContext()
  initCompanyArchiveFitHeading()
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPagedArchiveInteractions)
} else {
  initPagedArchiveInteractions()
}
